import React from "react";
import { Carousel as ReactCarousel } from "react-responsive-carousel";
import CopyBlock from "../CopyBlock";
import Icon from "../Icon";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import * as carouselStyles from "./Carousel.module.css";
import Testimonial from "../Testimonial";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Carousel = ({ backgroundColor, props }) => {
  const {
    autoPlay,
    infiniteLoop,
    interval,
    transitionTime,
    showStatus,
    showIndicators,
    showThumbs,
    stopOnHover,
    swipeable,
    useKeyboardArrows,
  } = props;

  const { items } = props;

  const prevArrowProps = {
    name: "fa-arrow-left",
    isBrand: false,
    type: "button",
    size: "2x",
    color: "brightBlue",
  };

  const nextArrowProps = {
    name: "fa-arrow-right",
    isBrand: false,
    type: "button",
    size: "2x",
    color: "brightBlue",
  };

  const selectedIndicatorProps = {
    name: "fa-circle",
    isSolid: true,
    color: "darkBlue",
    size: "lg",
    circleColor: "white",
  };

  const normalIndicatorProps = {
    name: "fa-circle",
    isRegular: true,
    color: "black",
    size: "lg",
    circleColor: "white",
  };

  const indicatorStyles = {
    width: 8,
    height: 8,
    display: "inline-block",
    margin: "0 8px",
    cursor: "pointer",
  };

  const Indicator = ({ isSelected }) => {
    if (isSelected) {
      return <Icon props={selectedIndicatorProps} />;
    } else {
      return <Icon props={normalIndicatorProps} />;
    }
  };

  return (
    <div
      className={carouselStyles.customCarousel}
      // data-aos="fade-up"
      // data-aos-offset={100}
    >
      <div className={carouselStyles.content}>
        <ReactCarousel
          autoPlay={autoPlay}
          dynamicHeight={false}
          infiniteLoop={infiniteLoop}
          interval={interval}
          transitionTime={transitionTime}
          showArrows={false}
          showStatus={showStatus}
          showIndicators={showIndicators}
          showThumbs={showThumbs}
          stopOnHover={stopOnHover}
          swipeable={swipeable}
          useKeyboardArrows={useKeyboardArrows}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <div
                className={`${carouselStyles.arrow} ${carouselStyles.prevArrow}`}
              >
                <Icon
                  props={prevArrowProps}
                  label={label}
                  type="button"
                  onClick={() => {
                    onClickHandler();
                  }}
                />
              </div>
            )
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <div
                className={`${carouselStyles.arrow} ${carouselStyles.nextArrow}`}
              >
                <Icon
                  props={nextArrowProps}
                  label={label}
                  type="button"
                  onClick={() => {
                    onClickHandler();
                  }}
                />
              </div>
            )
          }
          renderIndicator={(onClickHandler, isSelected, index, label) => {
            return (
              <li
                style={indicatorStyles}
                className={carouselStyles.carouselDots}
                onClick={onClickHandler}
              >
                <Indicator isSelected={isSelected} />
              </li>
            );
          }}
        >
          {items.map((item, index) => {
            const { id } = item.sys.contentType.sys;

            if (id === "testimonial") {
              return (
                <div
                  key={`${id}-${index}`}
                  className={carouselStyles.testimonialWrapper}
                >
                  <Testimonial
                    textColor={
                      backgroundColor && backgroundColor === "blue"
                        ? "white"
                        : "dark"
                    }
                    item={item}
                  />
                </div>
              );
            }

            if (id === "copyBlock") {
              return <CopyBlock props={item} />;
            }

            if (id === "image") {
              return (
                <div className={carouselStyles.imageContainer}>
                  <GatsbyImage
                    image={item.file && getImage(item.file)}
                    alt={item.alt}
                  />
                </div>
              );
            }
          })}
        </ReactCarousel>
      </div>
    </div>
  );
};

export default Carousel;
